import OrganisationSettings from "./OrganisationSettings";
export default OrganisationSettings;